import React from 'react';

import { connect } from 'react-redux';

class FavoriteIcon extends React.Component {
  render() {
    return (
      <svg>
        <path
     d="m 22.380398,10.600563 c 1.614432,-3.8264759 5.302505,-6.5001292 9.592191,-6.5001292 5.778515,0 9.940198,4.9432984 10.463408,10.8346152 0,0 0.282406,1.462429 -0.339207,4.095282 -0.846417,3.585671 -2.836056,6.771335 -5.51851,9.202583 L 22.380398,40.900366 8.4217199,28.232114 C 5.7392661,25.801666 3.7496265,22.615202 2.9032097,19.029531 2.2815973,16.396678 2.5640029,14.934249 2.5640029,14.934249 3.0872133,9.0429322 7.2488962,4.0996338 13.027411,4.0996338 c 4.290486,0 7.738554,2.6744533 9.352987,6.5009292 z"
       fill={this.props.color || "#DE171F"}
       />
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(FavoriteIcon);



// WEBPACK FOOTER //
// ./src/icons/favorite.js